import { apiBaseUrl } from 'app/src/msw/membership/api/apiBaseUrl'
import { familyMembersCollection } from 'app/src/msw/membership/initialSeed/familyMembers'
import { http, HttpResponse } from 'msw'

export const deleteFamilyMember = http.delete<{ familyMembersId: string }>(
  apiBaseUrl + '/familyMembers/:familyMembersId',
  async ({ params }) => {
    const { familyMembersId } = params

    await familyMembersCollection.deleteMany((q) => q.where({ familyMemberId: familyMembersId }))

    const status = 200

    return HttpResponse.json({ status: status }, { status: status })
  },
)
